import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import "./EscrowFinance.css";
import "../AboutA2Z/AboutA2Z.css";
import Subscribe from "../../../_Pages/_webapp/_mainHome/Subscribe";
import WebFooter from "../../../_components/_webapp/Footer/WebFooter";
import LoaderWithLogo from "../../../_components/Loader/LoaderWithLogo";
import toastr from "toastr";
import PaySafe from "../../../assets/images/ag-pay-safe.png";
import Supply from "../../../assets/images/escrow-supply.png";
import Deal from "../../../assets/images/escrow-deal.png";
import Yneedescrow from "../../../assets/images/Y-need-escrow.png";
import BuyerIcon from "../../../assets/images/Y_E_buyer_icon.png";
import SellerIcon from "../../../assets/images/Y_E_Seller_icon.png";
import BuyerYEImg from "../../../assets/images/Y_Escrow_Buyer.png";
import SellerYEImg from "../../../assets/images/Y_Escrow_Seller.png";
import HEW1 from "../../../assets/images/HEW1.png";
import Hew1hover from "../../../assets/images/HEW1-hover.png";
import Hew5hover from "../../../assets/images/HEW5-hover.png";
import Hew6hover from "../../../assets/images/HEW6-hover.png";

import HEW2 from "../../../assets/images/HEW2.png";
import HEW3 from "../../../assets/images/HEW3.png";
import HEW4 from "../../../assets/images/HEW4.png";
import HEW5 from "../../../assets/images/HEW5.png";
import HEW6 from "../../../assets/images/HEW6.png";
import EMail from "../../../assets/images/N_contact_email.png";
import ECall from "../../../assets/images/N_contact_phone.png";
import KYC from "../../../assets/images/kyc.png";
import { MdArrowForward } from "react-icons/md";

import { Validation } from "../../../_helpers/validation/Validation";
import { ContactUsService } from "../../../_services/CommnService/ContactUs/ContactUsService";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { multiLingual } from "../../../_components/Multilingualplaceholder/Multilingualplaceholder";
import { Helmet } from "react-helmet";
import { CommonVariables } from "../../../_constants/CommonVariables";
import ReCAPTCHA from "react-google-recaptcha";
import { captchaKey } from "../../../_constants/Config/AryaConstants";
import ValidationError from "../arya2.0/CommonComponents/ValidationError/ValidationError";
import isLogin from "../../../_helpers/Common/helper";
class EscrowFinance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      first_name: "",
      email: "",
      phone: "",
      message: "",
      isLoading: false,
      error: {},
      lang: "en",
      captchaToken: "",
      refreshCaptchaKey: 0,
    };
  }
  componentDidMount() {
    let lang = localStorage.getItem("lang");
    this.setState({
      lang: lang,
    });
  }
  unsetFormData = () => {
    this.setState({
      content: "",
      lang: "",
      first_name: "",
      email: "",
      phone: "",
      message: "",
      isLoading: false,
      error: {},
    });
  };

  onChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        this.setState({
          error: {},
        });
      }
    );
  };
  handleRefresh = () => {
    this.setState({
      refreshCaptchaKey: this.state.refreshCaptchaKey + 1
    });
  };
  captchChange = (value) => {
    this.setState({ error: { ...this.state.error, ["captchaToken"]: "" } });
    this.setState({ captchaToken: value });
    // setData((prev) => ({ ...prev, ["captchaToken"]: value }));
  };

  onExpired = (value) => {
    this.setState({ captchaToken: "" });
    this.setState({ error: { ...this.state.error, ["captchaToken"]: "" } });

    // setData((prev) => ({ ...prev, ["captchaToken"]: "" }));
  };

  createFormData() {
    var objdata = {
      first_name: this.state.first_name,
      last_name: "",
      phone_number: this.state.phone,
      email: this.state.email,
      message: this.state.message,
      location: "",
      landline_number: "",
      type: 3,
      commodity: "",
      funded_location: "",
      captcha_token: this.state.captchaToken,
    };
    return objdata;
  }

  onSubmit = async (e) => {
    e.preventDefault();
    var errobj = {};
    errobj = Validation(this.state, rules);
    if (!isLogin() && !this.state.captchaToken) {
      errobj.captchaToken =
        "Please check the box indicating 'I am not a robot' to submit your application";
    }
    this.setState({ error: errobj, isLoading: true });
    var flag = 0;
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    
    });

    if (flag === 0) {
      var registerdata = this.createFormData();
      const result = await ContactUsService.contactUs(registerdata);
      if (result?.data?.status_code === 200) {
        this.handleRefresh();
        toastr.info("Thank You");
        this.unsetFormData();
      } else {
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({
        isLoading: false,
      });
    }
  };

  callBack = () => {
    let lang = localStorage.getItem("land");
    this.setState({
      lang: lang,
    });
  };

  render() {
    const metaTags = document.getElementsByTagName("meta");
    for (const tag of metaTags)
      if (tag.name === "description")
        tag.content =
          "Trade agricultural commodities safely with Arya - Pay safe. Online Platform which offers payments with fully digital Escrow. Online escrow - simple and safe for buyers and sellers";

    return (
      <React.Fragment>
        <Helmet>
          <title>
            Trade with Arya - Pay Safe | Payments with fully Digital Escrow
          </title>
          {/* <meta name="keywords" content="Get loan on agri products, Get loan on agri commodities, Get loan on wheat,  Get loan on paddy,  Get loan on cotton,  Get loan on sugar, Get loan on maize, Get loan on pulses" /> */}
          <link
            rel="canonical"
            href="https://www.arya.ag/finance/arya-paysafe-escrow"
          />
        </Helmet>

        <SetHeader
          callBack={this.callBack}
          active={"story"}
          history={this.props.history}
        ></SetHeader>
        <LoaderWithLogo isLoading={this.state.isLoading} />

        <div className="N_escrow_finance">
          <Container>
            <Row>
              <Col>
                <div className="main_escrow_banner">
                  <div className="encrow_banner_heading">
                    <h2>
                      <MultiLanguageTranslation title="Protect your payments with fully digitally Escrow" />
                    </h2>
                    <img alt="" src={PaySafe} />
                  </div>
                  <div className="escrow_banner_desc1">
                    <ul>
                      <li>
                        <img alt="" src={Deal} />
                        <span>
                          <MultiLanguageTranslation title="Got a great deal from a new buyer, but don't trust him with payments" />{" "}
                          ?
                        </span>
                      </li>
                      <li>
                        <img alt="" src={Supply} />
                        <span>
                          <MultiLanguageTranslation title="Found a good supplier at right price, but don't trust with quality" />{" "}
                          ?
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="escrow_banner_desc2">
                    <div className="escrow_banner_desc2-bottom">
                      <ul>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Online escrow that is simple and safe for buyers and sellers" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="A licensed and compliant escrow service" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Free dispute investigation and resolution" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="The safest service to trust with your money" />
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="escrow_banner_desc2-bottom">
                      <ul>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Regularly audited by government authorities" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Prompt support to resolve all your questions" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Know the status of transaction at every step thorugh simple account login" />
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <section className="Y_Escrow_Finance">
          <Container>
            <Row>
              <Col>
                <div className="Y_Escrow_finance_header">
                  <h2>
                    <MultiLanguageTranslation title="Why Do I Need Escrow" />
                  </h2>
                </div>
                <div className="Y_Escrow_finance_desc">
                  <img alt="" src={Yneedescrow} className="img_NY" />
                  <div className="YEscrow_right">
                    <div className="YEscrow_right_Buyer buyer_YE">
                      <div className="buyer_YE_img">
                        <img alt="" src={BuyerYEImg} />
                      </div>
                      <div className="YEscrow_right_Buyer_heading">
                        <img alt="" src={BuyerIcon} />
                        <h3>
                          <MultiLanguageTranslation title="As Buyer" />
                        </h3>
                      </div>
                      <p className="YE_subheading">
                        <MultiLanguageTranslation title="Protect your transactions against delays and cancellations" />
                      </p>
                      <ul>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Keep your money secured until goods are shipped" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Access new sellers and markets to grow your business" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Fully verify seller's identity and compliance status" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Get your money back if the goods fail the inspection" />
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="YEscrow_right_Buyer seller_YE">
                      <div className="buyer_YE_img">
                        <img alt="" src={SellerYEImg} />
                      </div>
                      <div className="YEscrow_right_Buyer_heading">
                        <img alt="" src={SellerIcon} />
                        <h3>
                          <MultiLanguageTranslation title="As Seller" />
                        </h3>
                      </div>
                      <p className="YE_subheading">
                        <MultiLanguageTranslation title="Get paid on time and in full for shipped orders" />
                      </p>
                      <ul>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Sell more by building trust with buyers" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Secure full payment amount in an escrow before you ship" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Build your reputation as a reliable seller" />
                          </p>
                        </li>
                        <li>
                          <span>&#10003;</span>
                          <p>
                            <MultiLanguageTranslation title="Work only with verified buyers, eliminating post shipment hassles" />
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="H_Escrow_Work">
          <Container>
            <Row>
              <Col>
                <div className="H_Escrow_Work_sections">
                  <div className="H_Escrow_Work_unit unit-one">
                    <div className="H_Escrow_Work_sec">
                      <img alt="" className="wdhover" src={HEW1} />
                      <img alt="" className="hewHover" src={Hew1hover} />
                      <span>
                        <MultiLanguageTranslation title="STEP 1" />
                      </span>
                      <p>
                        <MultiLanguageTranslation title="Buyer and Seller agree on terms" />
                      </p>
                    </div>
                    <div className="H_Escrow_Work_sec">
                      <img alt="" src={HEW2} />
                      <span>
                        <MultiLanguageTranslation title="STEP 2" />
                      </span>
                      <p>
                        <MultiLanguageTranslation title="Add & Verify Documentation" />
                      </p>
                    </div>
                    <div className="H_Escrow_Work_sec">
                      <img alt="" src={HEW3} />
                      <span>
                        <MultiLanguageTranslation title="STEP 3" />
                      </span>
                      <p>
                        <MultiLanguageTranslation title="Buyer submits payment to escrow" />
                      </p>
                    </div>
                  </div>
                  <div className="H_Escrow_Work_heading">
                    <h2>
                      <MultiLanguageTranslation title="How Escrow Works" /> ?
                    </h2>
                    <p>
                      <MultiLanguageTranslation title="escroe_finance_page_arya_paysafe_is_the_most_secure" />
                    </p>
                  </div>
                  <div className="H_Escrow_Work_unit unit-3">
                    <div className="H_Escrow_Work_sec">
                      <img alt="" src={HEW4} />
                      <span>
                        <MultiLanguageTranslation title="STEP 4" />
                      </span>
                      <p>
                        <MultiLanguageTranslation title="Seller delivers commodity" />
                      </p>
                    </div>
                    <div className="H_Escrow_Work_sec">
                      <img alt="" className="wdhover" src={HEW5} />
                      <img alt="" className="hewHover" src={Hew5hover} />
                      <span>
                        <MultiLanguageTranslation title="STEP 5" />
                      </span>
                      <p>
                        <MultiLanguageTranslation title="Buyer approves commodity and quality" />
                      </p>
                    </div>
                    <div className="H_Escrow_Work_sec">
                      <img alt="" className="wdhover" src={HEW6} />
                      <img alt="" className="hewHover" src={Hew6hover} />
                      <span>
                        <MultiLanguageTranslation title="STEP 6" />
                      </span>
                      <p>
                        <MultiLanguageTranslation title="Arya PaySafe release Payment to Sellers" />
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="createandkyc">
          <Container>
            <Row>
              <Col md={8}>
                <div className="E_Create_account">
                  <h3>
                    <MultiLanguageTranslation title="Create your Escrow account now" />{" "}
                    !{" "}
                  </h3>
                  <form onSubmit={this.onSubmit}>
                    <div className="E_account">
                      <div>
                        <MultiLanguageTranslation title="Name" /> *
                      </div>
                      <input
                        className="form-name"
                        type="text"
                        name="first_name"
                        onChange={this.onChange}
                        value={this.state.first_name}
                        placeholder={multiLingual()["Enter your name"]}
                      />
                      {this.state.error &&
                        this.state.error.first_name !== "" && (
                          <div className="errorRed">
                            {this.state.error.first_name}
                          </div>
                        )}
                    </div>
                    <div className="E_account">
                      <div>
                        <MultiLanguageTranslation title="Phone Number" /> *
                      </div>
                      <input
                        className="form-phone"
                        type="number"
                        name="phone"
                        onChange={this.onChange}
                        value={this.state.phone}
                        placeholder={multiLingual()["Enter your phone number"]}
                      />
                      {this.state.error && this.state.error.phone !== "" && (
                        <div className="errorRed">{this.state.error.phone}</div>
                      )}
                    </div>
                    <div className="E_account">
                      <div>
                        <MultiLanguageTranslation title="Email" /> *
                      </div>
                      <input
                        className="form-mail"
                        type="text"
                        name="email"
                        onChange={this.onChange}
                        value={this.state.email}
                        placeholder={multiLingual()["Enter your email ID"]}
                      />
                      {this.state.error && this.state.error.email !== "" && (
                        <div className="errorRed">{this.state.error.email}</div>
                      )}
                    </div>
                    {!isLogin() && <div className="w-100">
                      <ReCAPTCHA
                        key={this.state.refreshCaptchaKey}
                        sitekey={captchaKey}
                        onChange={this.captchChange}
                        onExpired={this.onExpired}
                      />
                      {this.state.error.captchaToken && (
                        <ValidationError
                          text={this.state.error.captchaToken}
                          showIcon={false}
                          textClassName={"desk-input-error-style"}
                        // imageClassName={"mb-auto"}
                        // textClassName={style["input-error-style-radio"]}
                        />
                      )}
                    </div>}
                    <div className="E_account">
                      <div>&nbsp;</div>
                      <button
                        type="submit"
                        id="btnSubmit"
                        class="btn submitbtn"
                      >
                        <MultiLanguageTranslation title="Submit" />
                      </button>
                    </div>
                  </form>
                  <div className="or_form_div">
                    <p className="or_form">
                      <MultiLanguageTranslation title="OR" />
                    </p>
                  </div>
                  <div className="E_email_Call">
                    <div className="E_email">
                      <img alt="" src={EMail} />
                      <a href={"mailto:" + CommonVariables.arya_email}>
                        <MultiLanguageTranslation title="Email To" />:
                        {CommonVariables.arya_email}
                      </a>
                    </div>
                    <div className="E_Call">
                      <img alt="" src={ECall} />
                      <a href="tel:+91 90152 60260">
                        <MultiLanguageTranslation title="Call Us" />: +91 90152
                        60260
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="N_kyc">
                  <img alt="" src={KYC} />
                  <h4>
                    <MultiLanguageTranslation title="KYC Verification Documents" />
                  </h4>
                  <div className="KYC_points">
                    <ul>
                      <li>
                        <MdArrowForward></MdArrowForward>{" "}
                        <MultiLanguageTranslation title="Bank Statement" />
                      </li>
                      <li>
                        <MdArrowForward></MdArrowForward>{" "}
                        <MultiLanguageTranslation title="Pan Card" />
                      </li>
                      <li>
                        <MdArrowForward></MdArrowForward>{" "}
                        <MultiLanguageTranslation title="Aadhar Card" />
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="N_Faq">
          <Container>
            <Row>
              <Col>
                <div className="N_Faq_heading">
                  <h2>
                    <MultiLanguageTranslation title="Frequently Ask Questions" />{" "}
                    ?
                  </h2>
                </div>
                <div className="N_Acc_faq">
                  <Accordion allowZeroExpanded>
                    <AccordionItem key="0">
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <MultiLanguageTranslation title="What is Arya PaySafe?" />
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div className="N_acc_body">
                          <p>
                            <MultiLanguageTranslation title="escrow_page_title_Arya_PaySafe_escrow_service" />
                          </p>
                          <div className="N_acc_buyer">
                            <strong>
                              <MultiLanguageTranslation title="Buyer" />
                            </strong>
                            <div className="N_acc_buyer_points">
                              <MdArrowForward></MdArrowForward>
                              <span>
                                <MultiLanguageTranslation title="escrow_finance_page_The_buyer_is_assured_that" />
                              </span>
                            </div>
                            <div className="N_acc_buyer_points">
                              <MdArrowForward></MdArrowForward>
                              <span>
                                <MultiLanguageTranslation title="escrow_finance_page_the_buyer_is_also_protected" />
                              </span>
                            </div>
                          </div>
                          <div className="N_acc_buyer">
                            <strong>
                              <MultiLanguageTranslation title="Seller" />
                            </strong>
                            <div className="N_acc_buyer_points">
                              <MdArrowForward></MdArrowForward>
                              <span>
                                -{" "}
                                <MultiLanguageTranslation title="escrow_finance_page_the_seller_is_assure" />
                              </span>
                            </div>
                            <div className="N_acc_buyer_points">
                              <MdArrowForward></MdArrowForward>
                              <span>
                                -{" "}
                                <MultiLanguageTranslation title="escrow_page_title_The_seller_is_also" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>

                    {/* <AccordionItem key="1">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            Who can use Arya PaySafe Escrow Services?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                          
                                        </AccordionItemPanel>
                                    </AccordionItem> */}

                    <AccordionItem key="1">
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <MultiLanguageTranslation title="Does Arya PaySafe also help me connect to new buyers and sellers?" />
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div className="N_acc_body">
                          <p>
                            <MultiLanguageTranslation title="escrow_finance_page_no_arya_paysafe" />{" "}
                          </p>
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>
                    {/* <AccordionItem key="3">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            How long does it take to complete an escrow agreement?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                           
                                        </AccordionItemPanel>
                                    </AccordionItem> */}
                    {/* <AccordionItem key="4">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            What is covered under the escrow agreement created on Arya PaySafe?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            
                                        </AccordionItemPanel>
                                    </AccordionItem> */}
                    {/* <AccordionItem key="5">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            How does the buyer fund the Arya PaySafe escrow service?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                             
                                        </AccordionItemPanel>
                                    </AccordionItem> */}
                    {/* <AccordionItem key="6">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            When should the escrow be funded?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                             
                                        </AccordionItemPanel>
                                    </AccordionItem> */}

                    {/* <AccordionItem key="7">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            How much time does it take for escrow payments to be processed?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                             
                                        </AccordionItemPanel>
                                    </AccordionItem> */}
                    {/* <AccordionItem key="8">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            What is daily and monthly maximum limit to add/withdraw amount in Arya PaySafe?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                             
                                        </AccordionItemPanel>
                                    </AccordionItem> */}
                    {/* <AccordionItem key="9">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            When is the money released to the seller?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                             
                                        </AccordionItemPanel>
                                    </AccordionItem> */}
                    {/* 
                                    <AccordionItem key="10">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            How does Arya PaySafe verify that the seller has fulfilled their obligations before releasing the money?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                             
                                        </AccordionItemPanel>
                                    </AccordionItem> */}

                    {/* <AccordionItem key="11">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            What is the fee for the escrow service and who pays the fee?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                             
                                        </AccordionItemPanel>
                                    </AccordionItem> */}

                    {/* <AccordionItem key="12">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            What happens if the seller does not ship the products or is delayed?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                             
                                        </AccordionItemPanel>
                                    </AccordionItem> */}

                    {/* <AccordionItem key="13">
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                            What is required to complete my KYC/KYB process?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                             
                                        </AccordionItemPanel>
                                    </AccordionItem> */}
                  </Accordion>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="formContent">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>
                  <MultiLanguageTranslation title="escrow_finance_h1" />
                </h1>

                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="escrow_finance_p1" />
                  ) : (
                    <>
                      Escrow is a term that refers to a process through which
                      two or more parties carry out agreed-upon transactions.
                      The approach is popular because it provides a high degree
                      of security and transparency. The{" "}
                      <b>Arya escrow account</b> is distinguished by an
                      impartial third party who facilitates the transactions.
                      Due to the neutrality of the third party, escrow
                      safeguards the interests of all transacting parties
                      equally. This maintains a level playing field throughout
                      the transaction procedure.
                    </>
                  )}
                </p>

                <h2>
                  <MultiLanguageTranslation title="Secure your payments with completely digital escrow of Arya" />
                </h2>
                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="escrow_finance_p2" />
                  ) : (
                    <>
                      While deciding on <b>Arya Paysafe escrow</b>, you are
                      securing the following points:
                    </>
                  )}
                </p>

                <ul>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Simple and secure online escrow for buyers and sellers" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Escrow service that is licenced and compliant" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Investigation and settlement of disputes are entirely free" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="The most secure service with which to entrust your money" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Government officials conduct routine audits" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Prompt assistance to address all of your concerns" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Keep track of the progress of transactions at every stage with the help of simple account login" />
                    </p>
                  </li>
                </ul>

                <h3>
                  <MultiLanguageTranslation title="What benefits does Arya provide regarding payments with fully digital escrow?" />
                </h3>

                <b>
                  <MultiLanguageTranslation title="As a purchaser" />
                </b>
                <ul>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Safeguard Your Transactions From Delays And Cancellations" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Maintain Security of Your Funds Until Goods Are Shipped" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="To Expand Your Business, Gain Access To New Sellers And Markets" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Verify the seller's identity and compliance status thoroughly" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Refund If The Goods Fail The Inspection" />
                    </p>
                  </li>
                </ul>
                <b>
                  <MultiLanguageTranslation title="As a Vendor" />
                </b>
                <ul>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Receive Payment For Shipped Orders On Time And In Full" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Increase Your Sales By Establishing Trust With Buyers" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Before You Ship, Place the Entire Payment Amount In An Escrow Account" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Establish Your Credibility As A Reliable Seller" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <MultiLanguageTranslation title="Work With Only Verified Buyers to Avoid Post-Shipment Hassles" />
                    </p>
                  </li>
                </ul>

                <h4>
                  <MultiLanguageTranslation title="Why to select Arya escrow account?" />
                </h4>

                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="escrow_finance_p3" />
                  ) : (
                    <>
                      Our knowledge of{" "}
                      <a href="https://market.arya.ag/en/">Agri commodities</a>{" "}
                      and their quality standards, together with our granular
                      presence and important contacts across the value chain,
                      enables us to handle our valued clients' procurement
                      process effectively. We allow the acquisition of
                      high-quality goods and services via a range of approaches.
                    </>
                  )}
                </p>
                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="escrow_finance_p4" />
                  ) : (
                    <>
                      Due to the bridge of 'trust' that Arya escrows build;
                      digital escrows of Arya are fast becoming the preferred
                      transaction option for organizations and people. While
                      conventional escrows are inefficient and expensive,
                      digital escrows overcome this limitation.
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="N_stay_update">
          <div className="container">
            <div className="row">
              <Subscribe></Subscribe>
            </div>
          </div>
        </section>
        <WebFooter />
      </React.Fragment>
    );
  }
}

export default EscrowFinance;

const rules = [
  {
    field_name: "first_name",
    label: "Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "email",
    label: "Email",
    type: "email",
    isRequired: true,
  },
  {
    field_name: "phone",
    label: "Phone number",
    type: "phone",
    // min: 10,
    // max: 13,
    isRequired: true,
  },
];
